const loginRouter = [
  {
    path: '*',
    redirect: '/login'
  },
  {
    // 登录页面
    path: '/login',
    name: 'login',
    meta: {
      authc: true
    },
    component: () => import('@/page/login/login')
  },
  {
    // 官网登录 授权页
    path: '/auth',
    name: 'auth',
    meta: {
      authc: true
    },
    component: () => import('@/page/login/auth')
  },
  {
    // 忘记密码
    path: '/resetpassword',
    name: 'resetpassword',
    meta: {
      authc: true
    },
    component: () => import('@/page/login/resetpassword')
  },
  {
    // 用户隐私协议
    path: '/privacyPolicy',
    name: 'privacyPolicy',
    meta: {
      authc: true
    },
    component: () => import('@/page/login/privacyPolicy')
  },
  {
    // 注册账号
    path: '/register',
    name: 'register',
    meta: {
      authc: true
    },
    component: () => import('@/page/login/register')
  },
  {
    // 出行通知-疫情提醒
    path: '/travelInfo',
    name: 'travelInfo',
    meta: {
      authc: true
    },
    component: () => import('@/page/login/travelInfo')
  },
  {
    // 订单审批
    path: '/approveOrder',
    name: 'approveOrder',
    meta: {
      authc: true
    },
    component: () => import('@/page/login/approveOrder')
  }
]

export default loginRouter



// WEBPACK FOOTER //
// ./src/router/modules/login.js